import { licencaService } from '@/services/licencaService';

const state = {
  licencas: []
}

const getters = {
  licencas: state => state.licencas,
}

const actions = {
  async fetchLicencas({ commit }, { page, limit, status, query }) {
    commit('SET_LOADING', true);
    try {
      const response = await licencaService.getAll(page, limit, status, query);
      commit('SET_LICENCAS', response.data.data);
      commit('SET_LOADING', false);
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_LICENCAS', []);
      commit('SET_LOADING', false);
    }
  },
  async addLicenca({ commit, dispatch }, licenca) {
    commit('SET_LOADING', true);
    try {
      const response = await licencaService.create(licenca);
      commit('SET_LICENCA', response.data.data);
      commit('SET_LOADING', false);
      dispatch('fetchLicencas', { limit: 999 });
      return true;
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_LOADING', false);
      return false;
    }
  },
  async updateLicenca({ commit, dispatch }, updLicenca) {
    commit('SET_LOADING', true);
    try {
      const response = await licencaService.update(updLicenca);
      commit('UPDATE_LICENCA', response.data.data);
      commit('SET_LOADING', false);
      dispatch('fetchLicencas', { limit: 999 });
      return true;
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_LOADING', false);
      return false;
    }
  },
  async deleteLicenca({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      await licencaService.destroy(id);
      commit('DELETE_LICENCA', id);
      commit('SET_LOADING', false);
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_LOADING', false);
    }
  },
}

const mutations = {
  SET_LICENCAS: (state, licencas) => state.licencas = licencas,
  SET_LICENCA: (state, licenca) => state.licencas.push(licenca),
  UPDATE_LICENCA: (state, updLicenca) => {
    const index = state.licencas.findIndex(licenca => licenca._id === updLicenca._id)
    if (index !== -1) state.licencas.splice(index, 1, updLicenca);
  },
  DELETE_LICENCA: (state, id) => state.licencas = state.licencas.filter(licenca => licenca._id !== id)
}

export default {
  state,
  getters,
  actions,
  mutations
}